exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-table-head.end[data-v-85fba894] {\r\n    text-align: right;\n}\r\n", ""]);

// exports
